(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lab99-home-decant-rotator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initLab99DecantRotators(){
    document.querySelectorAll('.md-hero .md-hero__card.lab-decants').forEach(function(card){
      if(card.dataset.lab99RotatorReady==='1') return;
      var grid=card.querySelector('.lab-decants__grid');
      if(!grid) return;
      var slides=Array.prototype.slice.call(grid.querySelectorAll('.lab-decant'));
      if(!slides.length) return;
      card.dataset.lab99RotatorReady='1';
      grid.classList.add('is-rotating');
      var current=0,timer=null,interval=4000;
      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function show(index){
        current=(index+slides.length)%slides.length;
        slides.forEach(function(slide,i){
          var active=i===current;
          slide.classList.toggle('is-active',active);
          slide.setAttribute('aria-hidden',active?'false':'true');
          slide.tabIndex=active?0:-1;
        });
      }
      function stop(){if(timer){clearInterval(timer);timer=null;}}
      function start(){
        stop();
        if(reduce||slides.length<2||document.hidden) return;
        timer=setInterval(function(){
          if(!card.isConnected){stop();return;}
          show(current+1);
        },interval);
      }
      show(0);
      if(slides.length>1){
        card.addEventListener('mouseenter',stop);
        card.addEventListener('mouseleave',start);
        card.addEventListener('focusin',stop);
        card.addEventListener('focusout',function(){setTimeout(function(){if(!card.contains(document.activeElement)) start();},0)});
        document.addEventListener('visibilitychange',function(){document.hidden?stop():start()});
        start();
      }
    });
  }
  initLab99DecantRotators();
  document.addEventListener('shopify:section:load',function(){setTimeout(initLab99DecantRotators,0)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-decants-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('md-offer-countdown')) {
  customElements.define('md-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      this.duration = 9300000;
      this.output = this.querySelector('.md-offer-countdown__time');
      if (!this.output) return;
      const now = Date.now();
      let saved = 0;
      try { saved = Number(localStorage.getItem(this.dataset.storageKey)); } catch {}
      this.deadline = Number.isFinite(saved) && saved > 0 && saved <= now + this.duration ? saved : now + this.duration;
      this.tick = () => {
        const time = Date.now();
        if (time >= this.deadline) {
          this.deadline += (Math.floor((time - this.deadline) / this.duration) + 1) * this.duration;
          this.persist();
        }
        const seconds = Math.ceil((this.deadline - time) / 1000);
        const h = Math.floor(seconds / 3600);
        const m = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        const s = String(seconds % 60).padStart(2, '0');
        const text = h + ':' + m + ':' + s;
        if (this.output.textContent !== text) this.output.textContent = text;
      };
      this.persist();
      this.tick();
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }
    persist() {
      try { localStorage.setItem(this.dataset.storageKey, String(this.deadline)); } catch {}
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
      document.removeEventListener('visibilitychange', this.tick);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
